import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { formatDate } from '@ynap/intl-formatters'
import { IOrderTrackingData } from '../../../../utils/order-status/interfaces'

const bem = new BEMHelper('DeliveryTime')

type DeliveryTimeProps = {
    orderPrimaryStatus: IOrderTrackingData
    orderEstimatedDeliveryDate: string
    orderDeliveryDate: string
    messages: any
    locale: {
        country: string
        currency: string
        id: string
        langISO: string
        language: string
    }
    type: "order"|"return"
}

const DeliveryTime: React.FC<DeliveryTimeProps> = ({
    orderPrimaryStatus,
    orderEstimatedDeliveryDate,
    orderDeliveryDate,
    messages,
    locale,
    type
}) => {
    const formatDeliveryDateTime = (dateTime: string) => {
        // Check if date doesn't have a timeZone
        const noTimeZone = (/\d{4}-\d{2}-\d{2}$/).test(dateTime);
        return formatDate(new Date(dateTime), { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', ...(noTimeZone && { timeZone: "UTC" }) }, locale.id)
    }

    return (
            <div className={bem(null)}>
                {messages.orderTracking?.estimatedDelivery && <div className={bem('estimatedDeliveryMessage')}>{messages.orderTracking?.estimatedDelivery()}</div>}
                {!orderEstimatedDeliveryDate && !orderDeliveryDate && (
                    <span>{orderPrimaryStatus.deliveryTimeInfo}</span>
                )}
                {orderEstimatedDeliveryDate && !orderDeliveryDate && (
                    <div className={bem(null, 'estimatedDeliveryDate')}>
                        <span>{messages.orderTracking.estimatedDeliveryDate()}</span>
                        <p className={bem('date')}>{formatDeliveryDateTime(orderEstimatedDeliveryDate)}</p>
                    </div>
                )}
                {orderDeliveryDate && (
                    <span>
                        {type === "order" && messages.orderTracking.deliveredOn()}
                        {type === "return" && messages.returnTracking.returnedToWarehouseOn()}
                        <span className={bem('date')}>{formatDeliveryDateTime(orderDeliveryDate)}</span>
                    </span>
                )}
            </div>
    )

}

export default DeliveryTime
